import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { CmsConfig, provideDefaultConfig } from '@spartacus/core'
import { IconModule, SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { DispenserAgreementPlaceOrderComponent } from './dispenser-agreement-place-order.component'
import { DispenserOrderPlacedModule } from './dispenser-order-placed/dispenser-order-placed.module'

@NgModule({
  declarations: [DispenserAgreementPlaceOrderComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    IconModule,
    ReactiveFormsModule,
    SpinnerModule,
    DispenserOrderPlacedModule
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        DispenserAgreementPlaceOrderComponent: {
          component: DispenserAgreementPlaceOrderComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class DispenserAgreementPlaceOrderModule {}
